<template>
  <div class="block">
    <el-carousel :height="`${height}px`">
      <el-carousel-item v-for="(item, i) in list" :key="i">
        <!-- <h3 class="small">{{ item }}</h3> -->
        <img v-lazy="item.img" @click = "$emit('goTake', 3)" alt="">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        { img: 'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/banner.png' }, 
        { img: 'https://public-scloudservice-1253952448.cos.ap-guangzhou.myqcloud.com/website/banner2.png' }
      ]
    }
  },
  name: 'Banner',
  props: {
    height: {
      type: String,
      default: '950'
    }
  }
}
</script>

<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item{
  margin-bottom: 100%;
}
.el-carousel__item img{
	/* top:0;
	bottom:0;
	left:0;
	right:0;
	width:100%;
	margin:auto; */
  /* width:100%; */
  /* object-fit: cover;
  width: 100%; */
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* max-width: 100%;
  max-height: 100%; */
}
/deep/ .el-carousel__arrow {
  height: 80px;
  width: 80px;
}
/deep/ [class*=" el-icon-"], [class^=el-icon-]{
  font-weight: 700;
}
/deep/ .el-carousel__indicators--horizontal { 
  bottom: 40px;
}
/deep/ .el-carousel__indicator button{
  background-color: #fff;
  opacity: 1;
  height: 4px;
  width: 40px;
}
/deep/ .el-carousel__indicator.is-active button{
  background-color: #01A7EB;
  opacity: 1;
  height: 4px;
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue